import { combineReducers } from "redux";
import { reducer as formReducer } from 'redux-form';
import { snackbarReducer } from 'react-redux-snackbar';
import { loadingBarReducer } from 'react-redux-loading-bar';
import loginReducer from './LoginReducer';
import ForgetReducer from './ForgetReducer';
import SideMenu from './SideMenuReducer';
import Setting from './LayoutSettingReducer';
import SubHeader from './SubHeaderReducer';
import SocketReducer from './SocketReducer'

export default combineReducers({
   form: formReducer,
   userInfo: loginReducer,
   forgetPass: ForgetReducer,
   snackbar: snackbarReducer,
   sideMenu: SideMenu,
   subHeader: SubHeader,
   loadingBar: loadingBarReducer,
   setting: Setting,
   socket:SocketReducer,
});
